const TreeState = {
    blocks : [],
    paths : [],
    variables : [],
    blocksVisible : [],
    pathsVisible : [],
    children : [],
    categories : [],
    zoneSelectBlocks : { x : 0, y : 0},
    isDrawing : false,
    lowVersion : false,
    ctrlKey : false,
    shiftKey: false,
    pressDown : false,
    debugJumpIndex : 0,
    fullscreen : false,
    fetching : true

}

export default TreeState;